import { FC, useState } from 'react';

import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { Input } from '@/components/ui/Input';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const LAST_NAME_NAME = 'last_name';

interface Props {
  name?: string;
}

const InputLastName: FC<Props> = ({ name = LAST_NAME_NAME }) => {
  const { i18n } = useLingui();
  const { control, trigger } = useFormContext();
  const [focused, setFocused] = useState(false);

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        validate: (value) => {
          if (!value || value.trim().length < 2)
            return i18n.t('Uzupełnij nazwisko');
          if (/\d/.test(value)) return i18n.t('Nazwisko jest niepoprawne');
          return true;
        },
      }}
      render={({
        field: { onBlur, onChange, ...field },
        fieldState: { error },
      }) => (
        <FormItem className="col-span-3 sm:col-span-2">
          <FormControl>
            <Input
              label={i18n.t('Nazwisko')}
              error={error?.message}
              success={!focused && !error && !!field.value}
              autoComplete="family-name"
              onFocus={() => setFocused(true)}
              onBlur={() => {
                setFocused(false);
                onBlur();
              }}
              onChange={(e) => {
                onChange(e);
                if (error) trigger(name);
              }}
              {...field}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default InputLastName;
